import React, { useEffect, useState } from 'react';
import { FiMessageCircle, FiTrash2, FiFileText, FiHeadphones, FiVideo } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { checkIncludeProfiles } from 'src/app/utils/getAuthorityLevel';
import moment from 'moment';
import { useAuditorium } from 'src/app/hooks/useAuditorium';
import { useParams } from 'react-router-dom';
import {
  LessonMessageContainer,
  LessonMessageActions,
  LessonMessage,
  LessonMessageContent,
  LessonMessageDateTime,
  LessonMessageInfo,
  LessonMessageName,
  LessonMessageUser,
  LessonMessageFileThumb,
  LessonMessageFile,
  LessonMessageFileContent,
  LessonMessageFileTitle,
  LessonMessageFileMeta
} from '@/components/custom/lesson';
import { Button } from '@/components/ui/button';

export default function MessageCard(props) {
  const { deleteMessage, setMessageIds } = useAuditorium();
  const { text = true, message, onlyFile, chats } = props;
  const [file, setFile] = useState();
  const id = useParams().auditoriumId;

  const isAdmin = !checkIncludeProfiles({ only: ['student'] });

  useEffect(() => {
    if (message?.['auditorium-files']?.length > 0) {
      setFile(message?.['auditorium-files']?.[0]);
    }
  }, []);

  const handleSendMessageIds = () => {
    const messageIds = {
      messageId: message.id,
      lessonId: message['auditorium-lesson']?.id,
      messageBody: message.body
    };
    setMessageIds(messageIds);
  };

  const handleDelete = () => {
    Swal.fire({
      title: 'Deseja mesmo excluir esta mensagem?',
      text: 'Esta ação não poderá ser desfeita',
      confirmButtonText: 'Sim',
      showDenyButton: true,
      denyButtonText: 'Não',
      showCloseButton: true
    }).then(res => {
      if (res.isConfirmed) {
        deleteMessage(id, message, onlyFile, chats);
      }
    });
  };

  const icon = file => {
    const splitFilename = file.filename.split('.');
    const extension = splitFilename[splitFilename.length - 1];
    switch (true) {
      case ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'mpeg', '3gp', 'webm'].includes(extension):
        return (
          <LessonMessageFileThumb>
            <FiVideo />
          </LessonMessageFileThumb>
        );
      case ['mp3', 'wav', 'flac', 'aac', 'ogg', 'wma', 'aiff', 'm4a', 'alac', 'opus'].includes(extension):
        return (
          <LessonMessageFileThumb>
            <FiHeadphones />
          </LessonMessageFileThumb>
        );
      default:
        return (
          <LessonMessageFileThumb>
            <FiFileText />
          </LessonMessageFileThumb>
        );
    }
  };

  return (
    <LessonMessageContainer>
      <LessonMessage>
        <LessonMessageUser>
          {/* <Avatar
            className="avatar--xs"
            src={message?.user?.image?.url}
          /> */}
          <LessonMessageInfo>
            <LessonMessageName title={message?.user?.name}>{message?.user?.name}</LessonMessageName>
            <LessonMessageDateTime>
              <time datetime={moment(message?.['created-at']).format('HH:mm')}>{moment(message?.['created-at']).format('HH:mm')}</time>
            </LessonMessageDateTime>
          </LessonMessageInfo>
        </LessonMessageUser>

        <LessonMessageContent>
          {text && <div dangerouslySetInnerHTML={{ __html: message?.body }} />}

          {file && (
            <LessonMessageFile>
              {file.filename && icon(file)}
              <LessonMessageFileContent>
                <LessonMessageFileTitle>{file?.filename}</LessonMessageFileTitle>
                <LessonMessageFileMeta>{`Prof. ${message.user.name} em ${moment(message?.['created-at']).format('DD/MM/YYYY')}`}</LessonMessageFileMeta>
              </LessonMessageFileContent>
              <Button
                variant="outline"
                size="sm"
                wide
                asChild
              >
                <a
                  href={file?.file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Baixar
                </a>
              </Button>
            </LessonMessageFile>
          )}

          {onlyFile && (
            <LessonMessageFile>
              {message?.filename && icon(message)}
              <LessonMessageFileContent>
                <LessonMessageFileTitle>{message.filename}</LessonMessageFileTitle>
                <LessonMessageFileMeta>{`Prof. ${message.user?.name ?? ''} em ${moment(message?.['created-at']).format('DD/MM/YYYY')}`}</LessonMessageFileMeta>
              </LessonMessageFileContent>
              <Button
                variant="outline"
                size="sm"
                wide
                asChild
              >
                <a
                  href={message.file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Baixar
                </a>
              </Button>
            </LessonMessageFile>
          )}
        </LessonMessageContent>
      </LessonMessage>

      {(!onlyFile || isAdmin) && (
        <LessonMessageActions>
          {!onlyFile && (
            <FiMessageCircle
              className="text-primary"
              onClick={handleSendMessageIds}
            />
          )}

          {isAdmin && (
            <FiTrash2
              className="text-danger"
              onClick={handleDelete}
            />
          )}
        </LessonMessageActions>
      )}
    </LessonMessageContainer>
  );
}
